export const accountCountryTypes = {
  Undetermined: 0,
  US: 1,
  NonUS: 2,
};
